jQuery(document).ready(function(){
  
  jQuery("#article").addClass("article");
  jQuery("#index").addClass("home");
  jQuery("#product").addClass("product-detail");

  //jQuery(".brand li").first().addClass("active");
  

  
  jQuery(".top-wrap").click(function(e){
	console.log("clicked!!");
       	
    if(  jQuery(this).parent().hasClass("active"))
    {
      jQuery(this).parent().removeClass("active");
    }
    else
    {
       jQuery(".brand li").removeClass("active");	
   	 jQuery(this).parent().addClass("active");
    }
   });
  

 
  
  
  // best sallers owl carousel 
  
  jQuery('.pro-lists').owlCarousel({
    loop:true,
    margin:25,
    responsiveClass:true,
      responsive:{
            0:{
                items:1,
                nav:true
            },
            767:{
                items:1,
                nav:false
            },
            1000:{
                items:1,
                nav:true,
                loop:true
            }
          }
	}); 
  
  // our brand carousel 
  
  	jQuery('.our-brands-listing').owlCarousel({
    loop:true,
    margin:5,
    responsiveClass:true,
      responsive:{
            0:{
                items:5,
                nav:true
            },
            767:{
                items:6,
                nav:false
            },
            1000:{
                items:6,
                nav:true,
                loop:true
            }
          }
	});
  
  
  
  // Trustpilot review carousel
	jQuery('.client-reviews-lists').owlCarousel({
    loop:true,
    margin:40,
    responsiveClass:true,
      responsive:{
            0:{
                items:1,
                nav:true
            },
            768:{
                items:2,
                nav:true
            },
            1000:{
                items:3,
                nav:true,
                loop:true
            }
          }
	});
  	  	
  
  
// sticky header 
 if(jQuery( window ).width() <= 767)
   {  
     jQuery(window).scroll(function() {
          var scroll = jQuery(window).scrollTop();

            if(scroll >= 50)
            {
              jQuery(".site-header").addClass("sticky");
              jQuery("html").addClass("responsive-sticky");
            }
            else
            {
               jQuery(".site-header").removeClass("sticky");
               jQuery("html").removeClass("responsive-sticky");

            }
      });  	  	
   }
  
  // category listing slider for responsive view
  if(jQuery( window ).width() <= 767)
    
  {
      jQuery('.banner_tab').owlCarousel({
        loop:true,
        margin:5,
        responsiveClass:true,
          responsive:{
                0:{
                    items:4,
                    nav:true
                },
                767:{
                    items:5,
                    nav:true
                }
              }
        });
    
    jQuery('.review_in').owlCarousel({
        loop:true,
        margin:0,
        responsiveClass:true,
          responsive:{
                0:{
                    items:1,
                    nav:true
                },
                767:{
                    items:1,
                    nav:true
                }
              }
        });
   if(jQuery( window ).width() <= 767)
   {  
    jQuery(window).scroll(function() {
      var scroll_top = jQuery(window).scrollTop();
      if(scroll_top >= 300)
      {
        jQuery(".site-header").addClass("sticky");
		jQuery("html").addClass("responsive-sticky");
      }
      else
      {
        jQuery(".site-header").removeClass("sticky");
		jQuery("html").removeClass("responsive-sticky");

      }
    });
   }  
    
    jQuery('.nav-close').click(function(e){
      e.preventDefault();
      jQuery('.nav-collapse').addClass('closed');
      jQuery('.nav-collapse').removeClass('opened');
      jQuery('.nav-toggle').removeClass('active');
      jQuery('html').removeClass('no-scroll');
    });
    
    }

  // change text 
  
  jQuery(".nav-collapse ul li:eq(0) a").text("Home");
  
  jQuery('.faq-block .txt-content').hide();
  jQuery('.faq-block.active .txt-content').show();
  jQuery('.faq-block.active h5').find('span').addClass('minus');
  jQuery('.faq-block h5').on('click', function(){
    jQuery('.faq-block').removeClass('active');
    jQuery(this).closest('.faq-block').find('.txt-content').slideToggle();
    jQuery(this).closest('.faq-block').addClass('active');
    jQuery(this).find('span').toggleClass('minus');
  });
  
  jQuery('footer').find('#Subscribe').click(function(){
    var email = jQuery('footer').find('input[type="email"]').val();
    var emailReg = '/^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/';
    if(email == '' || !emailReg.test(email)) {
      jQuery('footer').find('input[type="email"]').addClass('invalid');
      return false;
    }
    else {
      jQuery('footer').find('input[type="email"]').removeClass('invalid');
    }
  });
  
  jQuery('.search-form').find('button').click(function(){
    var search = jQuery('.search-form').find('input').val();
    if(search == '') {
      jQuery('.search-form').find('input').addClass('invalid');
      return false;
    }
  });
  
  var main_path = window.location.href;
  jQuery(".checkout-steps li").each(function(){
    var inner_path = jQuery(this).find("a").attr("href");
    if(main_path == inner_path)
    {
      jQuery(this).addClass("active");
    }
  });
  jQuery('.description-list-nav').insertAfter('.desc-nav-destination');
  
  jQuery('.description-list').find('.desc-title').each(function(){
    var title = jQuery(this).find('h3').text();
    var img = jQuery(this).find('img').attr('src');
    if(typeof img != 'undefined' && img != '') {
    	jQuery('.description-list-nav ul').append('<li><a href="javascript:void(0)"><img src="'+img+'" alt="'+title+'"><p>'+title+'</p></a></li>');
    }
    else {
      	jQuery('.description-list-nav ul').append('<li><a href="javascript:void(0)"><p>'+title+'</p></a></li>');
    }
  });
  
  
  
 // var b =jQuery('ul.description-list > li').eq(jQuery(this).parent().index()).offset();
  //var c = b.top;
 // var headerheight = jQuery(".site-header").height();
  //var menuheight = jQuery('.description-list-nav').height();
  //~ jQuery('.description-list-nav li a').on('click',function(){
    //~ 
   //~ // var stickyheight = jQuery(".sticky-nav").height();
    //~ jQuery('html,body').animate({scrollTop:jQuery('ul.description-list > li').eq(jQuery(this).parent().index()).offset().top-jQuery(".description-list-nav").height()},'slow');
  //~ });
  
 // active class based on url
 if(jQuery( window ).width() >= 767) {
    jQuery('.description-list-nav li a').on('click',function(){
	var path = jQuery(this).html();
	var path1 = jQuery('.description-list-nav li a').first().html();
	var main_position = jQuery(".description-list-nav").offset();
    var element_top =  main_position.top;
	console.log(top);
	var top = jQuery(window).scrollTop();
	
	var minus = jQuery('.desc-list').outerHeight();
	if(minus <=100)
	{
		minus=minus-40;
	}
	
			if(top <= 1700) {
					console.log(top);
					jQuery('html,body').animate({
						scrollTop:jQuery('ul.description-list > li').eq(jQuery(this).parent().index()).offset().top-jQuery(".description-list-nav").outerHeight()-minus
					}, 1000);
				
			}
			else {
				console.log('else');
				jQuery('html,body').animate({
					scrollTop:jQuery('ul.description-list > li').eq(jQuery(this).parent().index()).offset().top-jQuery(".description-list-nav").outerHeight()+1
				}, 1000);
			}

	return false;
 });
 }
else
{   
	
		jQuery('.description-list-nav li a').on('click',function(){
	   console.log('mobile');
        var minus = jQuery('.desc-list').outerHeight();
		// var stickyheight = jQuery(".sticky-nav").height();
		jQuery('html,body').animate({scrollTop:jQuery('ul.description-list > li').eq(jQuery(this).parent().index()).offset().top-(jQuery(".description-list-nav").outerHeight()-200)},'slow');
	  });
}
  
  
  
  
 if(jQuery("body").hasClass("home"))
 {
   jQuery(".nav-collapse ul").find("li:eq(0) a").addClass("active");
 }
  
  
  
 if(jQuery("body").hasClass("account"))
 {
   var main_url = window.location.pathname;
   var partial_url = jQuery(".footer_spotlight .sp01:eq(2)").find("li a").attr("href");
   //alert(partial_url);
   if(main_url == partial_url )
   {
     jQuery(".footer_spotlight .sp01:eq(2)").find("li:eq(0)").addClass("active");
   }
 }
  
 if(jQuery("body").hasClass("bullguard-affiliate-profit-share-make-extra-money-program"))
 {
   var main_url = window.location.pathname;
   var partial_url = jQuery(".footer_spotlight .sp01:eq(0)").find("li:eq(7) a").attr("href");
   if(main_url == partial_url)
   {
     jQuery(".footer_spotlight .sp01:eq(0)").find("li:eq(7)").addClass("active");
   }
 }
  
 if(jQuery("body").hasClass("t-amp-cs"))
 {
   var main_url = window.location.pathname;
   var partial_url = jQuery(".footer_spotlight .sp01:eq(0)").find("li:eq(6) a").attr("href");
   if(main_url == partial_url)
   {
     jQuery(".footer_spotlight .sp01:eq(0)").find("li:eq(6)").addClass("active");
   }
 }
   
 if(jQuery("body").hasClass("blog"))
 {
   
     jQuery(".footer_spotlight .sp01:eq(2)").find("li:eq(3)").addClass("active");
   
 }
 
 if(jQuery("body").hasClass("article"))
 {
   
     jQuery(".footer_spotlight .sp01:eq(2)").find("li:eq(3)").addClass("active");
   
 }
 
 if(jQuery("body").hasClass("best-sellers"))
 {
   
     jQuery(".footer_spotlight .sp01:eq(1)").find("li:eq(5)").addClass("active");
   
 }
 
  
  
  // contact form custom validation 
  jQuery("#cn-form").click(function(){
      var names =  jQuery("#ContactFormName").val();
      var emails = jQuery("#ContactFormEmail").val();	
      var phno = jQuery("#ContactFormPhone").val();
      var msg =  jQuery("#ContactFormMessage").val();
      var flag = 0;  
      
      if(names == "")
      {
		jQuery("#ContactFormName").addClass("error");
		flag = 1;
      }
      else
      {
		jQuery("#ContactFormName").removeClass("error");
      }
      
      if(emails == "")
      {
		jQuery("#ContactFormEmail").addClass("error");
		flag = 1;
      }
      else if(!emails.match(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i))
      {
		  jQuery("#ContactFormEmail").addClass("error");
			flag = 1;
      }
      else
      {
		jQuery("#ContactFormEmail").removeClass("error");
      }
      
      if(phno == "")
      {
		jQuery("#ContactFormPhone").addClass("error");
		flag = 1;
      }
      else
      {
		jQuery("#ContactFormPhone").removeClass("error");
      }
      
      if(msg  == "")
      {
		jQuery("#ContactFormMessage").addClass("error");
		flag = 1;
      }
      else
      {
		jQuery("#ContactFormMessage").removeClass("error");
      }
      if(flag == 1)
      {
        jQuery('.errors').html('One or more fields have an error. Please check and try again.');
        jQuery('.errors').show();
        setTimeout( function(){
          jQuery('.errors').fadeOut();
        }, 7000);
		return false;
      }
      else {
        jQuery('.errors').html('');
        jQuery('.errors').hide();
      }
  });   
  
  setTimeout( function(){
    jQuery('.note.form-success').fadeOut();
  }, 7000);
  
  // registration form validation
  
  jQuery("#rg-btn").click(function(){
      var fname =  jQuery("#FirstName").val();
      var lname =  jQuery("#LastName").val();
      var mail = jQuery("#Email").val();	
      var pass = jQuery("#CreatePassword").val();
      var flag = 0;  
      
      if(fname == "")
      {
		jQuery("#FirstName").addClass("error");
		flag = 1;
      }
      else
      {
		jQuery("#FirstName").removeClass("error");
      }
      
      if(lname == "")
      {
		jQuery("#LastName").addClass("error");
		flag = 1;
      }
      else
      {
		jQuery("#LastName").removeClass("error");
      }
      
      if(mail == "")
      {
		jQuery("#Email").addClass("error");
		flag = 1;
      }
      else if(!mail.match(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i))
      {
		  jQuery("#Email").addClass("error");
			flag = 1;
      }
      else
      {
		jQuery("#Email").removeClass("error");
      }
      
      if(pass  == "")
      {
		jQuery("#CreatePassword").addClass("error");
		flag = 1;
      }
      else
      {
		jQuery("#CreatePassword").removeClass("error");
      }
      if(flag == 1)
      {
		return false;
      }
  }); 
  
  //login form validation
  jQuery(".login_btn").click(function(){
      var mails = jQuery("#CustomerEmail").val();	
      var passs = jQuery("#CustomerPassword").val();
      var flag = 0;  
      
      if(mails == "")
      {
		jQuery("#CustomerEmail").addClass("error");
		flag = 1;
      }
      else if(!mails.match(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i))
      {
		  jQuery("#CustomerEmail").addClass("error");
			flag = 1;
      }
      else
      {
		jQuery("#CustomerEmail").removeClass("error");
      }
      
      if(passs  == "")
      {
		jQuery("#CustomerPassword").addClass("error");
		flag = 1;
      }
      else
      {
		jQuery("#CustomerPassword").removeClass("error");
      }
      if(flag == 1)
      {
		return false;
      }
  });

  // make sticky product detail menu 
 if(jQuery("body").hasClass("product-detail"))
 { 
    jQuery(".description-list-nav").wrap("<div class='desc-list'></div>");
  
  if(jQuery( window ).width() >= 767) {
    
    var main_position = jQuery(".description-list-nav").offset();
    var element_top =  main_position.top;
    
    jQuery(window).scroll(function() {
		
        var scroll_top = jQuery(window).scrollTop();
      
		//console.log(scroll_top+">="+element_top);

        if(scroll_top >= element_top)
        {
          jQuery(".description-list-nav").addClass("sticky-nav");
          
        }
      else
      {         
         if(scroll_top <= 2000)
          {
            jQuery(".description-list-nav").removeClass("sticky-nav");

          } 
      }
      var minus = jQuery('.desc-list').outerHeight();
    jQuery('.description-list li').each(function() {
        
	  if(jQuery(window).scrollTop() >= jQuery(this).offset().top - minus) {
		  var text = jQuery(this).find('.desc-content').find('.desc-title h3').text();
		 
		jQuery('.description-list-nav ul li').each(function() {
		   var text_manu=jQuery(this).find('a p').text();
		  if(text==text_manu)
		  { 
			jQuery('.description-list-nav ul li').removeClass('active');
			jQuery(this).addClass('active');
		  }
		});
	  
	  }
	  });
    
    });
  } 
 } 
  // back to top button 
 jQuery(window).scroll(function(){
    
        if(jQuery(this).scrollTop() > 100){
            jQuery('#top-scroll').fadeIn();
        }else{
            jQuery('#top-scroll').fadeOut();
        }
    }); 
  
   jQuery('#top-scroll').click(function(){
        jQuery("html, body").animate({ scrollTop: 0 }, 1000);
        return false;
    });
  
  
 /* jQuery(".pro-specification-popup").click(function(){
    
    jQuery(".pro-liecnse-info").addClass("show");
    
  }); */
  
	var content = jQuery(".pro-liecnse-info").html();  
  jQuery(".pro-specification-popup").click(function(){
    jQuery.fancybox({ 
      
      	'content': content
      });
  
  });
  
  jQuery(".cart-faq > img").click(function(){
    jQuery.fancybox({ 
      'content': content
    });
  });
  
  jQuery('.compare-link a').click(function(){
    var href = jQuery(this).attr('href');
    jQuery.fancybox({ 
      'href' : href
    });
    return false;
  });

  
 /* var main_price = jQuery(".text-right").find("span").text();
  //var price = main_price.split(",");
  //alert(price);
   $("#ProductSelect2").on("change",function(){
	var selectedValue = $(this).val();
     alert(selectedValue);
     var main_value = selectedValue.split(" ");
     //alert(main_value);
     var total = selectedValue + main_price;
     //alert(price);
     //$(".text-right").find("span").append(total); 
	});*/
  
  $(window).scroll(function() {
   			 clearTimeout($.data(this, 'scrollTimer'));
    	 
      if($(".description-list-nav").hasClass("sticky-nav"))
      {  
           $.data(this, 'scrollTimer', setTimeout(function() {
        		$(".description-list-nav").slideUp("slow");
    }, 5000));
      }     
}); 
  
  $(window).on("scroll",function(){
    $(".description-list-nav").slideDown("slow",function(){
    	setTimeout(2000);	
    
    });
  });
  
  
  //var current_url = jQuery(location).attr('href');

  //var array_params = current_url.split('?');
  //contact_posted=true
  //var param = array_params[array_params.length-1];
  //if(param == 'contact_posted=true') {
    //jQuery.fancybox({
      //'content' : '<div><p>Thank you for your message, we will be in contact with you shortly.</p></div>'
    //});
  //}
  
  jQuery('.add-notes').click(function(e){
  	e.preventDefault();
    jQuery('.add-notes-text').slideToggle();
  });
  
  var timeout;
  jQuery('.faq-title').click(function(e){
    e.preventDefault();
    if(typeof(timeout) != 'undefined' && timeout != '')
    {
      clearTimeout(timeout);
    }

    if(jQuery(this).hasClass('active-faq'))
    {
        jQuery('.faq-desc').addClass('close-faq');
        jQuery(this).removeClass('active-faq');
        jQuery(this).closest('li').removeClass('active-li');
        jQuery(this).next('.faq-desc').removeClass('active-faq-content');
        jQuery(this).next('.faq-desc').slideUp();
        jQuery(this).removeClass('leaving');
    }
  	else
  	{ 
     	jQuery('.faq-desc').addClass('close-faq');
        jQuery('.faq-title').removeClass('active-faq');
        jQuery('.faq-title').closest('li').removeClass('active-li');
        jQuery('.faq-title').next('.faq-desc').removeClass('active-faq-content');
        jQuery('.faq-title').next('.faq-desc').slideUp();
        jQuery('.faq-title.leaving').removeClass('leaving');
    
        jQuery(this).next('.faq-desc').removeClass('close-faq');
        jQuery(this).addClass('active-faq');
        jQuery(this).closest('li').addClass('active-li');
        jQuery(this).next('.faq-desc').addClass('active-faq-content');
        jQuery(this).next('.faq-desc').slideDown();
      	
      if(jQuery( window ).width() > 1024) {
      	if(jQuery(this).hasClass('active-faq')) {
          jQuery( ".active-li" ).mouseleave(function(event) {
              if(jQuery( ".active-faq" ).hasClass('leaving')) {
              }
              else {
                jQuery( ".active-faq" ).addClass('leaving');
              }
              if(jQuery( ".active-faq" ).hasClass('leaving')) {
                timeout = setTimeout( function(){
                  //alert('leaving');
                  jQuery('.active-faq.leaving').next('.faq-desc').slideUp();
                  jQuery('.active-faq.leaving').closest('li').removeClass('active-li');
                  jQuery('.active-faq.leaving').next('.faq-desc').removeClass('active-faq-content');
                  jQuery('.active-faq.leaving').removeClass('active-faq');
                  jQuery('.leaving').removeClass('leaving');
                }, 8000);
                
              }
            jQuery(this).off(event);
          });
        }
      }
      
      else {
        if(jQuery(this).hasClass('active-faq')) {
        	if(jQuery( ".active-faq" ).hasClass('leaving')) {
            }
            else {
              jQuery( ".active-faq" ).addClass('leaving');
            }
            if(jQuery( ".active-faq" ).hasClass('leaving')) {
              timeout = setTimeout( function(event){
                //alert('leaving');
                jQuery('.active-faq.leaving').next('.faq-desc').slideUp();
                jQuery('.active-faq.leaving').closest('li').removeClass('active-li');
                jQuery('.active-faq.leaving').next('.faq-desc').removeClass('active-faq-content');
                jQuery('.active-faq.leaving').removeClass('active-faq');
                jQuery('.leaving').removeClass('leaving');
                jQuery(this).off(event);
              }, 8000);
              
            }
        }
      }
  	}

  });
  
  jQuery('#ProductSelect').on('change', function(){
    var val = jQuery(this).val();
    
    jQuery(this).find('option').each(function(){
      if(jQuery(this).attr('value') == val)
      {
        var jsprice = jQuery(this).attr('data-tab');
        //alert(jsprice);
        jQuery('.first-form .product__price').find('.js-price').html(jsprice);
      }
    });
  });
  
  jQuery('#ProductSelectnew').on('change', function(){
    var value = jQuery(this).val();
    jQuery(this).find('option').each(function(){
      if(jQuery(this).attr('value') == value)
      {
        var jsprice2 = jQuery(this).attr('data-tab');
        jQuery('.second-form .product__price').find('.js-price').html(jsprice2);
      }
    });
  });
  
  jQuery('.privacy label').on('click', function(e){
    e.preventDefault();
    jQuery('html').addClass('scroll-stop');
  	jQuery('.privacy label').fancybox({
      href: '#privacy_popup',
      helpers : { 
			  overlay : {closeClick: false}
			},
      'afterClose' : function () { 
          jQuery('html').removeClass('scroll-stop');
      },
      'afterShow' : function() {
        jQuery('html').addClass('scroll-stop');
      },
      'onComplete': function() {
          jQuery("#fancybox-wrap").css({'top':'20px', 'bottom':'auto'});
       }
    });
  	
  });
 
  jQuery('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if (jQuery('#privacy_check').is(':checked')) {
      jQuery('.privacy').removeClass('invalid-check');
      jQuery('.privacy-error').text('');
      jQuery(this).submit();
    }
    else {
      jQuery('.privacy').addClass('invalid-check');
      jQuery('.privacy-error').text('To proceed with the order you must accept our Privacy Policy.');
      return false;
    }
  });
  
  jQuery('.checkout-link').on('click', function() {
    if (jQuery('#privacy_check').is(':checked')) {
      jQuery('.privacy').removeClass('invalid-check');
      jQuery('.privacy-error').text('');
    }
    else {
      jQuery('.privacy').addClass('invalid-check');
      jQuery('.privacy-error').text('To proceed with the order you must accept our Privacy Policy.');
      return false;
    }
  });
  
              jQuery('.additional-checkout-button').hide();

    jQuery('.paypalcheckout').on('click', function() {
    if (jQuery('#privacy_check').is(':checked')) {
      jQuery('.privacy').removeClass('invalid-check');
      jQuery('.privacy-error').text('');

    }
    else {
      jQuery('.privacy').addClass('invalid-check');
      jQuery('.privacy-error').text('To proceed with the order you must accept our Privacy Policy.');
      return false;
    }
  });
      $("#privacy_check").click(function() {

      if (jQuery('#privacy_check').is(':checked')) {
                        jQuery('.additional-checkout-button').show();
                          jQuery("#backendbutton").hide();
        if(jQuery.browser.msie){
   jQuery('.additional-checkout-button').css({"display":"block"});
}

      }
        else{
                  jQuery("#backendbutton").show();
                        jQuery('.additional-checkout-button').hide();



        }
      });
  
  
  
  if(jQuery('.rte--indented-images div').hasClass('smart-banner-wrap'))
  {

  jQuery('body').addClass("smart-bullguard");
  }
  jQuery('.smart-banner-wrap').parents('.commom-pages').removeClass('section-gapping');
  
 jQuery('.smart-scoll-ul').on('initialized.owl.carousel changed.owl.carousel', function(e) {
    if (!e.namespace)  {
      return;
    }
    var carousel = e.relatedTarget;
   jQuery('.smart-couter').text(carousel.relative(carousel.current()) + 1 + '/' + carousel.items().length);
  }).owlCarousel({
    items: 1,
    loop:true,
    margin:0,
    nav:true
  });

  
  
  ///////////contact form bullguard pop up///////////
  
  jQuery("#smart-pop-btn").click(function(){
      var names =  jQuery("#ContactFormName").val();
      var emails = jQuery("#ContactFormEmail").val();	
      var phno = jQuery("#contactFormTelephone").val();
      var msg =  jQuery("#ContactFormMessage").val();
      var privcycheck = jQuery('#privacy_check').is(':checked')
      var flag = 0;  
    
      
      if(names == "")
      {
		jQuery("#ContactFormName").addClass("error");
		flag = 1;
      }
      else
      {
		jQuery("#ContactFormName").removeClass("error");
      }
      
      if(emails == "")
      {
		jQuery("#ContactFormEmail").addClass("error");
		flag = 1;
      }
      else if(!emails.match(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i))
      {
		  jQuery("#ContactFormEmail").addClass("error");
		  jQuery(".smart-emailerror").show();
		  jQuery(".smart-emailerror").text("Please enter a valid email address.");
		  setTimeout(function(){
		jQuery(".smart-emailerror").hide();

		},10000);
		  
			flag = 1;
      }
      else
      {
		jQuery("#ContactFormEmail").removeClass("error");
		jQuery(".smart-emailerror").hide();
		
      }
      
      if(phno == "")
      {
		jQuery("#contactFormTelephone").addClass("error");
		flag = 1;
      }
      else
      {
		jQuery("#contactFormTelephone").removeClass("error");
      }
      
      if(msg  == "")
      {
		jQuery("#ContactFormMessage").addClass("error");
		flag = 1;
      }
      else
      {
		jQuery("#ContactFormMessage").removeClass("error");
      }
    
     if (jQuery('#privacy_check').is(':checked')) {
      jQuery('.privacy').removeClass('error');
      jQuery('.privacy-error').text('');
    }
    else {
      
      jQuery('.privacy').addClass('error');
      jQuery('.privacy-error').text('To proceed with the order you must accept our Privacy Policy.');
     
      flag = 1;
    }
      if(flag == 1)
      {
        jQuery('.errors').html('One or more fields have an error. Please check and try again.');
        jQuery('.errors').show();
        setTimeout( function(){
          jQuery('.errors').fadeOut();
        }, 7000);
		return false;
      }
      else {
        jQuery('.errors').html('');
        jQuery('.errors').hide();
      }
  });  
  
  jQuery('.smart-open').click(function(e){
    jQuery('html').addClass("no-scroll");

e.preventDefault();
jQuery('body').addClass("smart-popup");

});
jQuery('.smart-close').click(function(){
  jQuery('html').removeClass("no-scroll");

jQuery('body').removeClass("smart-popup");
  jQuery("#ContactFormName").removeClass("error");
jQuery("#ContactFormEmail").removeClass("error");
jQuery("#contactFormTelephone").removeClass("error");
jQuery("#ContactFormMessage").removeClass("error");
 jQuery('.errors').hide();
 jQuery(".smart-emailerror").hide();
 jQuery(".form-success").hide();
      jQuery("#ContactFormName").val('');
      jQuery("#ContactFormEmail").val('');
      jQuery("#contactFormTelephone").val('');
      jQuery("#ContactFormMessage").val('');
   jQuery('#privacy_check').prop('checked', false);
  jQuery('.privacy').removeClass('error');
      jQuery('.privacy-error').text('');
  
      

});
  
var url      = jQuery.trim(window.location.href);
if (url.indexOf("?") >= 0)
{
    var tempdata = url.split("?")
    console.log(tempdata);
    console.log(tempdata.length);
    if(tempdata.length > 1)
    {
        if(tempdata[1] == "contact_posted=true#contact_form" || tempdata[1] == "contact_posted=true")
        {
        
          jQuery('body').addClass("smart-popup");
           setTimeout( function(){
           jQuery('body').removeClass("smart-popup");
        }, 7000);
          
         
          
        
        }
    
    }

}   
  
  
  jQuery('body').has('.bullguard-business-internet-security')
{

jQuery('body').addClass('bullguard');

}
  
///**** webdesign page 
  
 jQuery(".btn_link a").on('click',function(){			

    jQuery('body,html').animate({scrollTop:jQuery('#contact-section').offset().top - 30 },1000);

  });
  
  
  jQuery("#btn-contact").click(function(){
      var name =  jQuery("#ContactFormName").val();
      var emails = jQuery("#ContactFormEmail").val();	     
      var msg =  jQuery("#ContactFormMessage").val();      
      var flag = 0;  
    
      
      if(name == "")
      {
        jQuery('.name-error').show();
		jQuery("#ContactFormName").addClass("error");
        jQuery('.name-error').text("Please enter your name.");
		flag = 1;
      }
      else
      {
        jQuery('.name-error').hide();
		jQuery("#ContactFormName").removeClass("error");
      }
      
      if(emails == "")
      {
        jQuery('.email-error').show();
		jQuery("#ContactFormEmail").addClass("error");
        jQuery('.email-error').text("Please enter your email address.");
		flag = 1;
      }
      else 
      {
        if(!emails.match(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i))
        {
		  jQuery("#ContactFormEmail").addClass("error");
          jQuery('.email-error').text("Please enter a valid email address.");
        }
        else
        {        
          jQuery('.email-error').hide();
          jQuery("#ContactFormEmail").removeClass("error");
          
        }

      }
      
      if(msg  == "")
      {
        jQuery('.msg-error').show();
		jQuery("#ContactFormMessage").addClass("error");
        jQuery('.msg-error').text("Please enter your message.")
		flag = 1;
      }
      else
      {
        jQuery('.msg-error').hide();
		jQuery("#ContactFormMessage").removeClass("error");
      }
      if(flag == 1)
      { 
        jQuery('.form-success').hide();
        jQuery('.errors').html('One or more fields have an error. Please check and try again.');
        jQuery('.errors').show();
      	return false; 
      }
      else 
      {
    	jQuery('.web .form-success').show();
        jQuery('.errors').hide();
        return true;
      }
  });  
  

    jQuery('#contact-section input,#contact-section textarea,#contact-section email').each(
		function(index){  
			var input = jQuery(this);
          	input.on('focus', function() {
                jQuery(this).parent().addClass("has-focus");
            });
          
          input.on('focusout', function() {
              if(jQuery(this).val() == '') {
                  jQuery(this).parent().removeClass("has-focus");
              }
		   }); 
          
    });
  
   jQuery('#contact-section input[type="text"],#contact-section input[type="email"],#contact-section textarea').each(
          function(index){  
              var input = jQuery(this);
              if(input.val()=='')
              {
                  jQuery(input).parent().removeClass("has-focus");

              }else
              {
                  jQuery(input).parent().addClass("has-focus");	
              }
              //console.log('Type: ' + input.attr('type') + 'Name: ' + input.attr('name') + 'Value: ' + input.val());
      });
  
    url = window.location.href;
    url = url.split("/");
  	url = url[url.length-1];
   
  jQuery(function(){
  	if(url == "web-design?contact_posted=true")
    {
     jQuery('body,html').animate({scrollTop:jQuery('#contact-section').offset().top - 30 },1000);
    }
      
  });  

   
});

 